module.exports = __webpack_public_path__ + "static/video-poster-88a2d2c5c9788410dcd75e6f98d91a59.jpg";